import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { GridItem, Text } from '@chakra-ui/react';
import Latex from 'react-latex-next';
const TableColumnFC = ({ name, columnSx, columnNode }) => {
    return (_jsx(GridItem, { minH: "24px", sx: columnSx, children: _jsx(Text, { fontSize: "12px", color: "bodyText", textAlign: "center", children: columnNode ? _jsx(_Fragment, { children: columnNode }) : _jsx(Latex, { children: name }) }) }));
};
export const TableColumn = memo(TableColumnFC);
//# sourceMappingURL=TableColumn.js.map